import { IStandardAPIResponse, ITeamRole } from "../../vm";
import { httpClient, handleErrorResp } from "../UtilService";

export async function getAllShiftManagers(): Promise<
  IStandardAPIResponse<Array<ITeamRole>>
> {
  try {
    let res = await httpClient<Array<ITeamRole>>(`teams`, "GET");
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function getShiftManagersForDatacenter(
  datacenterId: string
): Promise<IStandardAPIResponse<Array<ITeamRole>>> {
  try {
    let res = await httpClient<Array<ITeamRole>>(`teams`, "GET", {
      datacenterId,
    });
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function addShiftManager(
  data: ITeamRole
): Promise<IStandardAPIResponse<ITeamRole>> {
  try {
    let res = await httpClient<ITeamRole>(`teams`, "PUT", data);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function updateShiftManager(
  data: ITeamRole
): Promise<IStandardAPIResponse<ITeamRole>> {
  try {
    let res = await httpClient<ITeamRole>(`teams/${data._id}`, "PATCH", data);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function updateShiftManagerPassword(
  userId: string,
  newPassword: string,
  role: number
): Promise<IStandardAPIResponse<string | undefined>> {
  try {
    let res = await httpClient<string | undefined>(
      `teams/${userId}/passwords`,
      "PATCH",
      { newPassword: newPassword, role: role }
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function deleteShiftManager(
  data: ITeamRole
): Promise<IStandardAPIResponse<ITeamRole>> {
  try {
    let res = await httpClient<ITeamRole>(`teams/${data._id}`, "DELETE");
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
